module.exports = __webpack_public_path__ + "static/og-image-0537f64a467097ecb287117ab51c7d6c.png";